import { jsx } from 'react/jsx-runtime';
const EGDSAlert = ({
  alertTemplateComponent: AlertTemplateComponent,
  alertTemplateData
}) => jsx("div", {
  children: jsx(AlertTemplateComponent, {
    ...alertTemplateData
  })
});
export { EGDSAlert };